import { useLocation } from 'react-router-dom';
import { makeStyles } from '@fluentui/react-components';
import TopBar from './TopBar';
import MainMenu from './MainMenu';

// z-index: 50 lieka kaip literali reikšmė (ne tokens.zIndex*) — kiti overlay
// komponentai (žr. src/admin/components/ui.jsx Drawer/Modal komentarą) remiasi
// tuo, kad šis elementas sukuria savo stacking context su būtent šia reikšme,
// tad Fluent zIndex token'ai (skirti Fluent vidinei sluoksniavimo sistemai) čia
// netinka.
const useStyles = makeStyles({
    staticHeader: {
        position: 'relative',
        zIndex: 50,
    },
    // position:sticky lieka "prilipęs" tik tol, kol jo TIESIOGINIS tėvinis elementas
    // (containing block) dar matomas ekrane — jei tas tėvas yra tik pačio header'io
    // dydžio (kaip anksčiau čia buvęs papildomas `wrapper` <div>, apgaubiantis TIK
    // šį elementą, NE visą puslapio turinį po juo), sticky "atsiriša" jau po
    // ~header'io aukščio scrollinimo, o ne lieka prilipęs per visą puslapį. Todėl
    // ČIA nebėra papildomo apgaubiančio <div>'o — šis elementas yra tiesioginis
    // FluentProvider konteinerio (kuris apgaubia VISĄ puslapio turinį, ne tik
    // header'į) vaikas, tad turi pakankamai vietos likti prilipęs per visą
    // scrollinimą (žr. /admin/bugs "Sita header dalis turi buti sticky prie top
    // kai yra scrolinama apacion").
    sticky: {
        position: 'sticky',
        top: 0,
        zIndex: 50,
    },
});

function Header() {
    const { pathname } = useLocation();
    const s = useStyles();
    if (pathname.startsWith('/konfiguratorius')) return null;
    const isHome = pathname === '/';

    // Namų puslapyje visas header'is (TopBar + MainMenu) lieka fiksuotas (sticky)
    // scrolinant zemyn — žr. /admin/bugs "Sita header dalis turi buti sticky prie
    // top kai yra scrolinama apacion" (ankstesnis sprendimas laikyti tik MainMenu
    // sticky, o TopBar leisti nuslinkti, pakeistas šiuo nauju prašymu).
    return (
        <div className={isHome ? s.sticky : s.staticHeader}>
            <TopBar />
            <MainMenu />
        </div>
    );
}

export default Header;
